import { render, staticRenderFns } from "./PieLegend.vue?vue&type=template&id=7f121ca6&scoped=true&"
import script from "./PieLegend.vue?vue&type=script&lang=js&"
export * from "./PieLegend.vue?vue&type=script&lang=js&"
import style0 from "./PieLegend.vue?vue&type=style&index=0&id=7f121ca6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f121ca6",
  null
  
)

export default component.exports